export async function copyToClipboard(text) {
  await navigator.clipboard.writeText(text);
  alert(`copied ${text} to clipboard!`);
}

export function fadeIn(node, { delay = 0, duration = 400 }) {
  return {
    delay,
    duration,
    css: (t) => `opacity: ${t}; transform: translateY(${(1 - t) * 20}px)`
  };
}